module.exports = __webpack_public_path__ + "img/sdg15.c209410a.svg";